import { createSelector } from 'reselect';
import { AUTH } from './constants';

const authState = (state) => state[AUTH];

export const selectToken = createSelector(
  authState,
  (_authState) => _authState.token,
);

export const selectLogin = createSelector(
  authState,
  (_authState) => _authState.isLogin,
);

export const selectAgentInfo = createSelector(
  authState,
  (_authState) => _authState.agentInfo,
);

export const selectForwardLogin = createSelector(
  authState,
  (_authState) => _authState.forwardLogin,
);

export const selectRoles = createSelector(
  authState,
  (_authState) => _authState.roles,
);

export const selectActiveProfile = createSelector(
  authState,
  (_authState) => _authState.activeProfile,
);

export const selectAllProfilesRoles = createSelector(
  authState,
  (_authState) => _authState.allProfilesRoles,
);

export const selectPersonalDetailInfo = createSelector(
  authState,
  (_authState) => _authState.personalDetailInfo,
);

export const selectBusinessInfo = createSelector(
  authState,
  (_authState) => _authState.businessInfo,
);

export const selectCheckHousehold = createSelector(
  authState,
  (_authState) => _authState.isHouseHold,
);

export const selectForgetPasswordFactors = createSelector(
  authState,
  (_authState) => _authState.forgetPasswordFactors,
);
